export default "__VITE_ASSET__eR7uk1Vh__"